import defaultConfig from 'ui-article/axel-publication-content/js/config';

const config = defaultConfig;

export default config;
